module.exports = __webpack_public_path__ + "assets/images/sleep_r.9adf956a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/sleep_r.png
// module id = 764
// module chunks = 1